import {useCallback, useEffect, useState} from "react"
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Snackbar,
    Stack,
    TextField
} from "@mui/material";
import {ContentCopy} from "@mui/icons-material";
import {isMobileDevice} from "../common.ts";

interface ShareDialogProps {
    readonly data?: ShareData;
    readonly title?: string;
    readonly text?: string;
    readonly onClose: () => void;
}

export default function ShareDialog(props: ShareDialogProps) {

    const [openShareDialog, setOpenShareDialog] = useState(false)

    const [openShareUrlHint, setOpenShareUrlHint] = useState(false)

    const onShareUrlAddToClipboardClick = useCallback(async () => {
        let shareUrl = props.data?.url
        if (shareUrl == null) {
            return
        }
        await navigator.clipboard.writeText(shareUrl)
        setOpenShareUrlHint(true)
    }, [props.data, setOpenShareUrlHint])

    const handleShareUrlHintClose = useCallback(() => {
        setOpenShareUrlHint(false)
    }, [setOpenShareUrlHint])

    const onCancelShare = useCallback(async () => {
        setOpenShareDialog(false)
    }, [setOpenShareDialog])

    useEffect(() => {

        if (props.data == undefined) {
            return
        }

        if (isMobileDevice() && !!navigator.share && navigator.canShare(props.data)) {
            try {
                navigator.share(props.data)
                    .catch((error: Error) => {
                        if (`${error}`.includes('AbortError')) {
                            // abort by user
                            return
                        }
                        console.error('Error sharing', error)
                    })
            } catch (error) {
                console.error('Error sharing', error)
            }
            return
        }

        // no native share -> fallback
        setOpenShareDialog(true)

    }, [props.data])

    return (
        <>
            <Dialog
                open={openShareDialog && props.data !== undefined}
                aria-labelledby="share-dialog-title"
                aria-describedby="share-dialog-description"
                onClose={onCancelShare}
            >
                <DialogTitle id="share-dialog-title">
                    {props.title ?? props.data?.title ?? "Teilen"}
                </DialogTitle>
                <DialogContent>

                    <DialogContentText id="share-dialog-description">
                        {props.text ?? props.data?.text}
                    </DialogContentText>

                    <Stack
                        direction="column"
                        padding={2}
                    >
                        <Snackbar
                            open={openShareUrlHint}
                            autoHideDuration={4000}
                            onClose={handleShareUrlHintClose}
                            message={`Der Link wurde in die Zwischenablage kopiert.`}
                        />
                        <Stack direction="row" sx={{verticalAlign: "center"}} spacing={1}>
                            <IconButton
                                onClick={onShareUrlAddToClipboardClick}
                                size="medium"
                            >
                                <ContentCopy cursor="pointer"/>
                            </IconButton>

                            <TextField
                                id="share-inline-url"
                                value={props.data?.url}
                                // size="small"
                                fullWidth
                                aria-readonly={true}
                                disabled={true}
                            />
                        </Stack>
                    </Stack>

                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancelShare} autoFocus>Schließen</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}